import { render, staticRenderFns } from "./CourseUnitDetail.vue?vue&type=template&id=4e63eae4&scoped=true"
import script from "./CourseUnitDetail.vue?vue&type=script&lang=js"
export * from "./CourseUnitDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseUnitDetail.vue?vue&type=style&index=0&id=4e63eae4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e63eae4",
  null
  
)

export default component.exports